import { AdditionalFacilitiesFormFields, AdditionalFacilitiesRequest } from 'src/@types';
import { currencyToNumber, stringToBoolean } from '../../../../../utils';
import { additionalFacilitiesFormFields } from '../config';
import { convertDateString } from '../../../../../utils/dates';

const prepareFormData = ({
  employerName,
  employerAddress,
  employerPostCode,
  employerPlace,
  contactPerson,
  employeeName,
  employeeAddress,
  employeePostCode,
  employeePlace,
  informationRequestedCanNotBeProvidedToTheEmployee,
  doesTheCompanyHasCollectiveLifeInsurancePolicy,
  isTheEmployeeInsuredByAnwInsurance,
  annualPaymentOfTheAnwInsurance,
  anwBenefitStartingStatement,
  percentageOfWagesDuringIllnessInTheFirstYearTheFirstHalf,
  percentageOfWagesDuringIllnessInTheFirstYearTheSecondHalf,
  percentageOfWagesDuringIllnessInTheSecondYearTheFirstHalf,
  percentageOfWagesDuringIllnessInTheSecondYearTheSecondHalf,
  wagesPercentageComposition,
  haveYouTakenOutWiaInsuranceForYourEmployees,
  wgaGapInsuranceClass,
  durationOfTheWgaHiaatInsuranceStatement,
  durationOfTheWgaHiaatInsuranceStatementOther,
  haveYouTakenOutTheWiaExcessInsurance,
  durationOfTheWiaExcessInsuranceStatement,
  durationOfTheWiaExcessInsuranceStatementOther,
  theCoveragePercentageOfTheWiaExcessInsurance,
  theCoveragePercentageOfTheWiaExcessInsuranceOther,
  haveYouTakenOutTheWiaIncomeSupplement,
  durationOfTheWiaIncomeSupplementStatement,
  durationOfTheWiaIncomeSupplementStatementOther,
  theCoveragePercentageOfTheWiaIncomeSupplement,
  theCoveragePercentageOfTheWiaIncomeSupplementOther,
  signatureName,
  signedAt,
  dateOfSignature,
  contactPersonPhoneNumber
}: AdditionalFacilitiesFormFields): AdditionalFacilitiesRequest => {
  return {
    employerName,
    employerAddress,
    employerPostCode,
    employerPlace,
    contactPerson,
    employeeName,
    employeeAddress,
    employeePostCode,
    employeePlace,
    informationRequestedCanNotBeProvidedToTheEmployee: stringToBoolean(
      informationRequestedCanNotBeProvidedToTheEmployee
    ),
    doesTheCompanyHasCollectiveLifeInsurancePolicy: stringToBoolean(
      doesTheCompanyHasCollectiveLifeInsurancePolicy
    ),
    isTheEmployeeInsuredByAnwInsurance: stringToBoolean(isTheEmployeeInsuredByAnwInsurance),
    annualPaymentOfTheAnwInsurance: currencyToNumber(annualPaymentOfTheAnwInsurance).toString(),
    anwBenefitStartingStatement,
    percentageOfWagesDuringIllnessInTheFirstYearTheFirstHalf,
    percentageOfWagesDuringIllnessInTheFirstYearTheSecondHalf,
    percentageOfWagesDuringIllnessInTheSecondYearTheFirstHalf,
    percentageOfWagesDuringIllnessInTheSecondYearTheSecondHalf,
    wagesPercentageComposition,
    haveYouTakenOutWiaInsuranceForYourEmployees: stringToBoolean(
      haveYouTakenOutWiaInsuranceForYourEmployees
    ),
    wgaGapInsuranceClass,
    durationOfTheWgaHiaatInsuranceStatement: durationOfTheWgaHiaatInsuranceStatementOther
      ? durationOfTheWgaHiaatInsuranceStatementOther
      : durationOfTheWgaHiaatInsuranceStatement,
    haveYouTakenOutTheWiaExcessInsurance: stringToBoolean(haveYouTakenOutTheWiaExcessInsurance),
    durationOfTheWiaExcessInsuranceStatement: durationOfTheWiaExcessInsuranceStatementOther
      ? durationOfTheWiaExcessInsuranceStatementOther
      : durationOfTheWiaExcessInsuranceStatement,
    theCoveragePercentageOfTheWiaExcessInsurance: theCoveragePercentageOfTheWiaExcessInsuranceOther
      ? theCoveragePercentageOfTheWiaExcessInsuranceOther
      : theCoveragePercentageOfTheWiaExcessInsurance,
    haveYouTakenOutTheWiaIncomeSupplement: stringToBoolean(haveYouTakenOutTheWiaIncomeSupplement),
    durationOfTheWiaIncomeSupplementStatement: durationOfTheWiaIncomeSupplementStatementOther
      ? durationOfTheWiaIncomeSupplementStatementOther
      : durationOfTheWiaIncomeSupplementStatement,
    theCoveragePercentageOfTheWiaIncomeSupplement:
      theCoveragePercentageOfTheWiaIncomeSupplementOther
        ? theCoveragePercentageOfTheWiaIncomeSupplementOther
        : theCoveragePercentageOfTheWiaIncomeSupplement,
    signatureName,
    signedAt,
    dateOfSignature: convertDateString(dateOfSignature),
    contactPersonName: contactPerson,
    contactPersonPhoneNumber
  };
};

const getDefaultValues = (): AdditionalFacilitiesFormFields => {
  return {
    employerName: additionalFacilitiesFormFields.employerName.defaultValue,
    employerAddress: additionalFacilitiesFormFields.employerAddress.defaultValue,
    employerPostCode: additionalFacilitiesFormFields.employerPostCode.defaultValue,
    employerPlace: additionalFacilitiesFormFields.employerPlace.defaultValue,
    contactPerson: additionalFacilitiesFormFields.contactPerson.defaultValue,
    contactPersonPhoneNumber: additionalFacilitiesFormFields.contactPersonPhoneNumber.defaultValue,
    employeeName: additionalFacilitiesFormFields.employeeName.defaultValue,
    employeeAddress: additionalFacilitiesFormFields.employeeAddress.defaultValue,
    employeePostCode: additionalFacilitiesFormFields.employeePostCode.defaultValue,
    employeePlace: additionalFacilitiesFormFields.employeePlace.defaultValue,
    informationRequestedCanNotBeProvidedToTheEmployee:
      additionalFacilitiesFormFields.informationRequestedCanNotBeProvidedToTheEmployee.defaultValue,
    doesTheCompanyHasCollectiveLifeInsurancePolicy:
      additionalFacilitiesFormFields.doesTheCompanyHasCollectiveLifeInsurancePolicy.defaultValue,
    isTheEmployeeInsuredByAnwInsurance:
      additionalFacilitiesFormFields.isTheEmployeeInsuredByAnwInsurance.defaultValue,
    annualPaymentOfTheAnwInsurance:
      additionalFacilitiesFormFields.annualPaymentOfTheAnwInsurance.defaultValue,
    anwBenefitStartingStatement:
      additionalFacilitiesFormFields.anwBenefitStartingStatement.defaultValue,
    percentageOfWagesDuringIllnessInTheFirstYearTheFirstHalf:
      additionalFacilitiesFormFields.percentageOfWagesDuringIllnessInTheFirstYearTheFirstHalf
        .defaultValue,
    percentageOfWagesDuringIllnessInTheFirstYearTheSecondHalf:
      additionalFacilitiesFormFields.percentageOfWagesDuringIllnessInTheFirstYearTheSecondHalf
        .defaultValue,
    percentageOfWagesDuringIllnessInTheSecondYearTheFirstHalf:
      additionalFacilitiesFormFields.percentageOfWagesDuringIllnessInTheSecondYearTheFirstHalf
        .defaultValue,
    percentageOfWagesDuringIllnessInTheSecondYearTheSecondHalf:
      additionalFacilitiesFormFields.percentageOfWagesDuringIllnessInTheSecondYearTheSecondHalf
        .defaultValue,
    wagesPercentageComposition:
      additionalFacilitiesFormFields.wagesPercentageComposition.defaultValue,
    haveYouTakenOutWiaInsuranceForYourEmployees:
      additionalFacilitiesFormFields.haveYouTakenOutWiaInsuranceForYourEmployees.defaultValue,
    wgaGapInsuranceClass: additionalFacilitiesFormFields.wgaGapInsuranceClass.defaultValue,
    durationOfTheWgaHiaatInsuranceStatement:
      additionalFacilitiesFormFields.durationOfTheWgaHiaatInsuranceStatement.defaultValue,
    durationOfTheWgaHiaatInsuranceStatementOther:
      additionalFacilitiesFormFields.durationOfTheWgaHiaatInsuranceStatementOther.defaultValue,
    haveYouTakenOutTheWiaExcessInsurance:
      additionalFacilitiesFormFields.haveYouTakenOutTheWiaExcessInsurance.defaultValue,
    durationOfTheWiaExcessInsuranceStatement:
      additionalFacilitiesFormFields.durationOfTheWiaExcessInsuranceStatement.defaultValue,
    durationOfTheWiaExcessInsuranceStatementOther:
      additionalFacilitiesFormFields.durationOfTheWiaExcessInsuranceStatementOther.defaultValue,
    theCoveragePercentageOfTheWiaExcessInsurance:
      additionalFacilitiesFormFields.theCoveragePercentageOfTheWiaExcessInsurance.defaultValue,
    theCoveragePercentageOfTheWiaExcessInsuranceOther:
      additionalFacilitiesFormFields.theCoveragePercentageOfTheWiaExcessInsuranceOther.defaultValue,
    haveYouTakenOutTheWiaIncomeSupplement:
      additionalFacilitiesFormFields.haveYouTakenOutTheWiaIncomeSupplement.defaultValue,
    durationOfTheWiaIncomeSupplementStatement:
      additionalFacilitiesFormFields.durationOfTheWiaIncomeSupplementStatement.defaultValue,
    durationOfTheWiaIncomeSupplementStatementOther:
      additionalFacilitiesFormFields.durationOfTheWiaIncomeSupplementStatementOther.defaultValue,
    theCoveragePercentageOfTheWiaIncomeSupplement:
      additionalFacilitiesFormFields.theCoveragePercentageOfTheWiaIncomeSupplement.defaultValue,
    theCoveragePercentageOfTheWiaIncomeSupplementOther:
      additionalFacilitiesFormFields.theCoveragePercentageOfTheWiaIncomeSupplementOther
        .defaultValue,
    signatureName: additionalFacilitiesFormFields.signatureName.defaultValue,
    signedAt: additionalFacilitiesFormFields.signedAt.defaultValue,
    dateOfSignature: additionalFacilitiesFormFields.dateOfSignature.defaultValue
  };
};

export { prepareFormData, getDefaultValues };
